module.exports = __webpack_public_path__ + "static/media/jumbotron-buy.aa058abd.svg";